import CrewAndVehicleForm from "../../components/Forms/CrewAndVehicleForm/CrewAndVehicleForm";

const CrewAndVehicle = () => {
  return <CrewAndVehicleForm />;
};

export default CrewAndVehicle;
